import React, { Component } from 'react';
import { createMaterialTopTabNavigator } from 'react-navigation-tabs';
import { Keyboard } from 'react-native';

import { Tabs, Tab } from '../ui';
import AllowedPartners from './AllowedPartners';
import BlockedPartners from './BlockedPartners';

const SettingsNavigation = createMaterialTopTabNavigator({
  ['Regular Partners']: { screen: AllowedPartners },
  ['Blocked Members']: { screen: BlockedPartners },
}, {
  swipeEnabled: true,
  backBehavior: 'none',
  tabBarPosition: 'top',
  tabBarComponent: props => (
    <WorkoutPartnersTabNaviagtion {...props} />
  ),
});

class WorkoutPartnersTabNaviagtion extends Component {
  render() {
    const navigation = this.props.navigation;
    const { routes, index } = this.props.navigationState;

    return (
      <Tabs>
        {routes.map((route, idx) => {
          const active = index === idx;
          return (
            <Tab
              active={active}
              amountOfTabs={routes.length - 1}
              currentTabIndex={idx}
              key={route.routeName}
              title={route.routeName}
              onPress={() => {
                Keyboard.dismiss();
                navigation.navigate(route.routeName);
              }}
            />
          );
        })}
      </Tabs>
    );
  }
}

export default SettingsNavigation;
